import React, { useState } from "react";
import { Box, Alert, Tabs, Tab } from "@mui/material";

import DashboardLayout from "../../layouts/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";

import SalesTab from "./Tabs/SalesTab";
import ArticlesTab from "./Tabs/ArticlesTab";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`penner-tabpanel-${index}`}
    aria-labelledby={`penner-tab-${index}`}
    {...other}
  >
    <Box sx={{ p: 3, display: value === index ? "block" : "none" }}>
      {children}
    </Box>
  </div>
);

const PennerManagementPage = () => {
  const [tabValue, setTabValue] = useState(0);
  const [error, setError] = useState(null);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setError(null);
  };

  return (
    <DashboardLayout>
      <MDBox>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <MDTypography variant="h4" fontWeight="medium" color="dark" mb={3}>
          Penner/Renner Management
        </MDTypography>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Sales" />
            <Tab label="Penner Articles" />
            <Tab label="Renner Articles" />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <SalesTab onError={setError} />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <ArticlesTab onError={setError} articleType="penner" />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <ArticlesTab onError={setError} articleType="renner" />
        </TabPanel>
      </MDBox>
    </DashboardLayout>
  );
};

export default PennerManagementPage;
